const core = () => import("@/pages/login/core.vue");
const bsglzxt = () => import("@/pages/login/bsglzxt.vue");
const cydsjzx = () => import("@/pages/login/cydsjzx.vue");
const baglzxt = () => import("@/pages/login/baglzxt.vue");
const cyqlzsglxt = () => import("@/pages/login/cyqlzsglxt.vue");
const xxfbxt = () => import("@/pages/login/xxfbxt.vue");
const xmtzglxt = () => import("@/pages/login/xmtzglxt.vue");
const zljgxt = () => import("@/pages/login/zljgxt.vue");
export default [
  {
    path: "/login/core",
    name: "core",
    component: core,
    meta: {
      title: "多系统切换",
      noCache: true,
      affix: true,
      path: ""
    }
  },
  {
    path: "/bsgl",
    name: "bsglzxt",
    component: bsglzxt,
    meta: {
      title: "标识管理子系统",
      noCache: true,
      affix: true,
      path: ""
    }
  },
  {
    path: "/dsj",
    name: "cydsjzx",
    component: cydsjzx,
    meta: {
      title: "产业大数据中心",
      noCache: true,
      affix: true,
      path: ""
    }
  },
  {
    path: "/bagl",
    name: "baglzxt",
    component: baglzxt,
    meta: {
      title: "备案管理子系统",
      noCache: true,
      affix: true,
      path: ""
    }
  },
  {
    path: "/qlzs",
    name: "cyqlzsglxt",
    component: cyqlzsglxt,
    meta: {
      title: "繁育养殖管理子系统",
      noCache: true,
      affix: true,
      path: ""
    }
  },
  {
    path: "/xxfb",
    name: "xxfbxt",
    component: xxfbxt,
    meta: {
      title: "信息发布系统",
      noCache: true,
      affix: true,
      path: ""
    }
  },
  {
    path: "/xmtz",
    name: "xmtzglxt",
    component: xmtzglxt,
    meta: {
      title: "畜牧屠宰管理系统",
      noCache: true,
      affix: true,
      path: ""
    }
  },
  {
    path: "/zljg",
    name: "zljgxt",
    component: zljgxt,
    meta: {
      title: "畜质量监管子系统",
      noCache: true,
      affix: true,
      path: ""
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/login.js